import React, {useEffect, useState} from 'react';
import { useHistory, useParams,useLocation } from 'react-router-dom';
import { Box, Typography, Grid, IconButton, Avatar } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { LinearProgress } from '@mui/material';
import RaazIcon from '../../../assets/images/DQProImages/RaazIcon.png'
import {getInsiderAssessmentPreviewService} from "../../../services/assessments.service";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "28px !important",
        },
    },
    questionContainer: {
        position: 'relative',
        minHeight: '400px',
        padding: theme.spacing(4),
        borderRadius: '8px',
        maxWidth: '1200px',
        margin: '0 auto',
        [theme.breakpoints.down('md')]: {
           marginTop:'auto',
           marginBottom:'auto',
        },
    },
    questionText: {
        textAlign: 'center',
        color: '#444 !important',
        fontSize: '1.9rem !important',
        fontWeight: '700 !important',
        lineHeight:'1 !important',
        marginBottom: '32px !important',
    },
    answerContainer: {
        // position: 'fixed',
        // bottom: '10%',
        height: '42%',
        marginTop:'50px',
        paddingBottom: '4vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowY: 'auto',
        [theme.breakpoints.down('md')]: {
            marginTop:'0px',
        },
    },
    optionItemBase: {
        borderRadius: '8px',
        border: '2px solid #fe696e',
        cursor: 'pointer',
        transition: '0.2s all',
        padding: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        boxSizing: 'border-box',
        minHeight: '64px',
        flex: 1,
    },

    maqOption: {
        flex: 1,
        width: '100%',
        // remove hardcoded height and margin
        overflow: 'auto',
        [theme.breakpoints.down('sm')]: {
            minWidth: '200px !important',
            fontSize: '0.9rem',
            height: 'auto',
        },
    },


    lsqOption: {
        flex: 1,
        textAlign: 'center',
        padding: '16px',
        minHeight: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        boxSizing: 'border-box',
        minWidth:'125px',
    },

    opqOption: {
        flex: 0.2,
        textAlign: 'center',
        padding: '16px',
        minHeight: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        boxSizing: 'border-box',
    },

    ynOption: {
        minWidth: '120px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '100px !important',
            fontSize: '0.85rem',
        },
    },

    selectedOption: {
        backgroundColor: '#fe696e',
        color: '#fff',
        borderColor: '#fe696e',
        '&:hover': {
            backgroundColor: '#fe696e',
        },
    },
    centeredOption: {
        margin: '0 auto',
    },
    navigationContainer: {
        position: 'absolute',
        top: '50%',
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        pointerEvents: 'none',
        zIndex: 1000,
        maxWidth: '1555px',
        left: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
    },
    navButton: {
        pointerEvents: 'auto',
        backgroundColor: 'transparent',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            width: '65px',
            height: '65px',
            borderRadius: '50%',
            backgroundColor: '#fe696e',
            zIndex: -1,
            top: '50%',
            left: '45%',
            transform: 'translate(-50%, -50%)',
        },
        '&:focus': {
            outline: 'none',
            border: 'none',
            boxShadow: 'none',
        },
        '&.Mui-disabled': {
            opacity: 0.3,
        },
        [theme.breakpoints.down('sm')]: {
            width: '40px',
            height: '40px',
            '&::before': {
                width: '80px',
                height: '80px',
            }
        }
    },
    navIcon: {
        color: '#fff',
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '25px',
        }
    },
    questionTypeIndicator: {
        backgroundColor: '#f0f0f0',
        padding: theme.spacing(1, 2),
        borderRadius: '20px',
        fontSize: '14px',
        fontWeight: 500,
        marginBottom: theme.spacing(2),
        display: 'inline-block',
    },
    progressBar: {
        width:'55% !important',
        margin:'15px auto',
        height: '13px !important',
        borderRadius: '13px',
        border:'1px solid #fe696e',
        backgroundColor:'#ffffff !important',
        '& .MuiLinearProgress-bar': {
            background: 'linear-gradient(to right, #E7466E, #FFAC46)',
        },
    },
    questionSubtitleTop: {
        color: '#fe696e',
        fontSize: '30px !important',
        fontWeight: "bold",
        textAlign:'center',
        lineHeight:'1.1 !important',
        marginBottom: '32px !important',
    },

    questionSubtitleBottom: {
        color: '#0097b2',
        fontSize: '30px !important',
        lineHeight:'1.1 !important',
        marginTop: '10px',
        fontWeight: "bold",
        textAlign:'center'
    },

}));

const dummyQuestions = [
    {
        id: 1,
        type: 'MCQ',
        question: 'Which of the following things that you often do to increase your online privacy?',
        options: ['I make my profile unavailable to the public.',
            'I limit online chatting only to people you know.',
            'I am careful about which friend requests to accept.',
            'I share things online only with close friends.'],
        correctAnswer: 'I share things online only with close friends.',
        userAnswer: null,
    },
    {
        id: 2,
        type: 'MAQ',
        question: 'Which of the following things that you often do to increase your online privacy?(Select all that apply)',
        options: ['I make my profile unavailable to the public.',
            'I limit online chatting only to people you know.',
            'I am careful about which friend requests to accept.',
            'I share things online only with close friends.'],
        correctAnswer: ['I share things online only with close friends.', 'I am careful about which friend requests to accept.',],
        userAnswer: [],
    },
    {
        id: 3,
        type: 'LSQ',
        question: 'Which of the following things that you often do to increase your online privacy?',
        options: ['True', 'False'],
        correctAnswer: 'True',
        userAnswer: null,
    },
    {
        id: 4,
        type: 'MCQ',
        question: 'Which of the following things that you often do to increase your online privacy?',
        options: ['I make my profile unavailable to the public.',
            'I limit online chatting only to people you know.',
            'I am careful about which friend requests to accept.',
            'I share things online only with close friends.'],
        correctAnswer: 'I share things online only with close friends.',
        userAnswer: null,
    },
    {
        id: 5,
        type: 'MAQ',
        question: 'Which of the following things that you often do to increase your online privacy?(Select all that apply)',
        options: ['I make my profile unavailable to the public.',
            'I limit online chatting only to people you know.',
            'I am careful about which friend requests to accept.',
            'I share things online only with close friends.'],
        correctAnswer: ['I share things online only with close friends.', 'I am careful about which friend requests to accept.',],
        userAnswer: [],
    },
];

const DQProPreviewAssessment = () => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const assessmentData = location.state?.assessment;
    const { code } = useParams();
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [questions, setQuestions] = useState(dummyQuestions);

    const handleOptionSelect = (option) => {
        setQuestions(prevQuestions => {
            return prevQuestions.map((question, index) => {
                if (index !== currentQuestionIndex) return question;

                const updatedQuestion = { ...question };

                if (question.type === 'MCQ' || question.type === 'LSQ') {
                    updatedQuestion.userAnswer = option;
                } else if (question.type === 'MAQ') {
                    updatedQuestion.userAnswer = question.userAnswer.includes(option)
                        ? question.userAnswer.filter(item => item !== option)
                        : [...question.userAnswer, option];
                }

                console.log('Updated question:', updatedQuestion);
                return updatedQuestion;
            });
        });
    };

    const handleExit = () => {
        history.push({
            pathname: `/dq_pro/product/view/${code}`,
            state: { assessment: assessmentData },
        });
    };

    const fetchInstruments = async () => {
        try {
            const response = await getInsiderAssessmentPreviewService(code);
            if (response?.data?.instruments) {
                console.log('API Response:', response.data);

                const fetchedQuestions = response.data.instruments.map((item, index) => {
                    let options = [];
                    try {
                        options = typeof item.instrument_response === 'string'
                            ? JSON.parse(item.instrument_response)
                            : item.instrument_response;

                        if (!Array.isArray(options)) {
                            options = [options];
                        }
                    } catch (error) {
                        console.error('Error parsing options:', error);
                        options = ['Option 1', 'Option 2']; // Fallback
                    }

                    return {
                        id: index + 1,
                        type: item.category_11 || 'MCQ',
                        instrument_question: item.instrument_question || 'No question text',
                        options: options,
                        question_subtitle_top: item.question_subtitle_top,
                        question_subtitle_bottom: item.question_subtitle_bottom,
                        ui_rules: item.ui_rules,
                        userAnswer: item.userAnswer || (item.category_11 === 'MAQ' ? [] : null),
                        correctAnswer: '',
                    };
                });

                console.log('Formatted Questions:', fetchedQuestions);
                setQuestions(fetchedQuestions);
            }
        } catch (error) {
            console.error('Error fetching assessment questions:', error);
        }
    };

    useEffect(() => {
        fetchInstruments().then(r => console.log(r));
    }, [code])

    const handleNextQuestion = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const handlePreviousQuestion = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
    };

    const isOptionSelected = (option) => {
        if (!questions.length) return false;
        const currentQuestion = questions[currentQuestionIndex];

        if (!currentQuestion) return false;

        if (currentQuestion.type === 'MCQ' || currentQuestion.type === 'LSQ') {
            return currentQuestion.userAnswer === option;
        } else if (currentQuestion.type === 'MAQ') {
            return currentQuestion.userAnswer?.includes(option) || false;
        }
        return false;
    };

    const isFreeTextQuestion = (question) => {
        if (!question) return false;
        return question.type === 'OPQ' &&
            question.options.includes('Free text');
    };

    const isNextDisabled = () => {
        if (!questions.length) return true;
        const currentQuestion = questions[currentQuestionIndex];

        if (!currentQuestion) return true;

        if (isFreeTextQuestion(currentQuestion)) {
            return false;
        }

        if (currentQuestion.type === 'MCQ' || currentQuestion.type === 'LSQ') {
            return currentQuestion.userAnswer === null;
        } else if (currentQuestion.type === 'MAQ') {
            return currentQuestion.userAnswer?.length === 0;
        }
        return true;
    };

    const calculateProgress = () => {
        return ((currentQuestionIndex + 1) / questions.length) * 100;
    };


    const renderOptions = () => {
        if (questions.length === 0) return null;
        const currentQuestion = questions[currentQuestionIndex];
        if (!currentQuestion || !currentQuestion.options) return null;
console.log(currentQuestion.type );
        const options = currentQuestion.options;
        const isLSQ = currentQuestion.type === 'LSQ';
        const isMCQ = currentQuestion.type === 'MCQ';
        const isYN = options.every(opt =>
            ['Yes', 'No', 'Maybe'].includes(opt) && options.length <= 3
        );
        const isMAQ = currentQuestion.type === 'MAQ';

        if (isMAQ) {
            const isOdd = options.length % 2 !== 0;
            const midIndex = Math.floor(options.length / 2);

            const column1 = options.slice(0, midIndex);
            const column2 = options.slice(midIndex, isOdd ? options.length - 1 : undefined);
            const lastOption = isOdd ? options[options.length - 1] : null;

            return (
                <div className={classes.answerContainer}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        width: '100%',
                        flexDirection:{xs:'column', sm:'row'}
                    }}>
                        {/* LEFT COLUMN */}
                        <div style={{
                            flex: 1,
                            maxWidth: '600px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                            gap: '16px',
                        }}>
                            {column1.map((option, index) => (
                                <div
                                    key={`left-${index}`}
                                    className={`${classes.optionItemBase} ${classes.maqOption} ${
                                        isOptionSelected(option) ? classes.selectedOption : ''
                                    }`}
                                    onClick={() => handleOptionSelect(option)}
                                >
                                    <Typography>{option}</Typography>
                                </div>
                            ))}
                        </div>

                        {/* RIGHT COLUMN */}
                        <div style={{
                            flex: 1,
                            maxWidth: '600px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                            gap: '16px',
                        }}>
                            {column2.map((option, index) => (
                                <div
                                    key={`right-${index}`}
                                    className={`${classes.optionItemBase} ${classes.maqOption} ${
                                        isOptionSelected(option) ? classes.selectedOption : ''
                                    }`}
                                    onClick={() => handleOptionSelect(option)}
                                >
                                    <Typography>{option}</Typography>
                                </div>
                            ))}
                        </div>
                    </Box>

                    {/* LAST ODD OPTION */}
                    {lastOption && (
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                            <div
                                className={`${classes.optionItemBase} ${classes.maqOption} ${
                                    isOptionSelected(lastOption) ? classes.selectedOption : ''
                                }`}
                                style={{ width: '100%', maxWidth: '1200px' }} // Full width
                                onClick={() => handleOptionSelect(lastOption)}
                            >
                                <Typography>{lastOption}</Typography>
                            </div>
                        </div>
                    )}
                </div>
                    );
        }

        let optionsPerRow;
        if (isLSQ || isMCQ) {
            optionsPerRow = Math.min(options.length, 5);
        } else if (isYN) {
            optionsPerRow = options.length;
        } else {
            optionsPerRow = Math.min(options.length, 3);
        }

        const rows = [];
        for (let i = 0; i < options.length; i += optionsPerRow) {
            rows.push(options.slice(i, i + optionsPerRow));
        }

        return (
            <div className={classes.answerContainer}>
                {rows.map((row, rowIndex) => (
                    <Box
                        key={rowIndex}
                        className={classes.optionsRow}
                        sx={{
                            display:'flex',
                            justifyContent: 'center',
                            gap: '16px',
                            width: '100%',
                            flexDirection:{xs:'column', sm:'row'}
                        }}
                    >
                        {row.map((option, optionIndex) => (
                            <div
                                key={optionIndex}
                                className={`${classes.optionItemBase}  ${isFreeTextQuestion(currentQuestion) ? classes.opqOption : ''} ${isLSQ || isMCQ ? classes.lsqOption : ''} ${isYN ? classes.ynOption : ''} ${isOptionSelected(option) ? classes.selectedOption : ''}`}
                                onClick={() => handleOptionSelect(option)}
                            >
                                <Typography>{option}</Typography>
                            </div>
                        ))}
                    </Box>
                ))}
            </div>
        );
    };

    return (
        <Box sx={{
            p: 4,
            position: 'relative',
            minHeight: '88vh',
            display:'flex',
            flexDirection:'column',
            justifyContent:'flex-start',
        }}>
            <Typography variant="h3" sx={{
                textAlign: "center",
                marginBottom: {sm: 4, xs: 1},
                marginTop: {xs: '0px', sm: '0px'}
            }} className={classes.title}>
                Assessment Preview
            </Typography>

            {/*<LinearProgress*/}
            {/*    variant="determinate"*/}
            {/*    value={calculateProgress()}*/}
            {/*    className={classes.progressBar}*/}
            {/*/>*/}

            <Box sx={{ position: 'relative', height: 70,mt:{xs:'30px', sm:'0'} }}>
                {/* Wrapper for centering */}
                <Box sx={{ width: {xs:'63%',sm:'55%'}, mx: 'auto', position: 'relative' }}>
                    {/* Background bar */}
                    <Box
                        sx={{
                            height: 10,
                            backgroundColor: '#e0e0e0',
                            borderRadius: 4,
                            width: '100%',
                        }}
                    />

                    {/* Filled bar */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            height: 10,
                            background: 'linear-gradient(to right, #E7466E, #FFAC46)',
                            borderRadius: 4,
                            width: `${calculateProgress()}%`,
                            transition: 'width 0.3s ease',
                        }}
                    />

                    {/* Moving Icon */}
                    <Box
                        component="img"
                        src={RaazIcon}
                        alt="progress icon"
                        sx={{
                            position: 'absolute',
                            top: -29,
                            left: `calc(${calculateProgress()}% - 25px)`,
                            width: 50,
                            height: 50,
                            transition: 'left 0.3s ease',
                        }}
                    />

                    {/* Question number at end of bar */}
                    <Typography
                        variant="h5"
                        sx={{
                            position: 'absolute',
                            top: -12,
                            right: -25,
                            transform: 'translateX(120%)',
                            whiteSpace: 'nowrap',
                        }}
                    >
                       <span style={{color: '#ff6468ff', fontWeight: 'bold',}}> {currentQuestionIndex + 1}</span>/{questions.length}
                    </Typography>
                </Box>
            </Box>


            <div className={classes.questionContainer}>
                {questions[currentQuestionIndex].question_subtitle_top && (
                    <Typography variant="h6" className={classes.questionSubtitleTop}>
                        {questions[currentQuestionIndex].question_subtitle_top}
                    </Typography>
                )}

                {questions[currentQuestionIndex].instrument_question && (
                <Typography variant="h4" className={classes.questionText}>
                    {questions[currentQuestionIndex].instrument_question}
                </Typography>
                )}

                {questions[currentQuestionIndex].question_subtitle_bottom && (
                    <Typography variant="h6" className={classes.questionSubtitleBottom}>
                        {questions[currentQuestionIndex].question_subtitle_bottom}
                    </Typography>
                )}

                {renderOptions()}

                {/*{currentQuestionIndex === questions.length - 1 && (*/}
                    <Box sx={{ textAlign: 'center', marginTop: 3 }}>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleExit()}
                        style={{
                                backgroundColor: '#ff6468',
                                color: '#ffffff',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                borderRadius: '8px',
                                padding: '9px 34px',
                            }}
                        >
                            Exit
                        </Button>
                    </Box>
                {/*)}*/}

            </div>

            <div className={classes.navigationContainer}>
                <IconButton
                    style={{}}
                    className={classes.navButton}
                    onClick={handlePreviousQuestion}
                    disabled={currentQuestionIndex === 0}
                >
                    <ArrowBackIosIcon className={classes.navIcon} />
                </IconButton>

                <IconButton
                    className={classes.navButton}
                    onClick={() => {
                        if (currentQuestionIndex === questions.length - 1) {
                            console.log('assessment completed');
                            // history.push('/dq_pro/products/assessments/result');
                        } else {
                            handleNextQuestion();
                        }
                    }}
                    disabled={isNextDisabled()}
                >
                    <ArrowForwardIosIcon className={classes.navIcon} />
                </IconButton>
            </div>
        </Box>
    );
};

export default DQProPreviewAssessment;